<template>
  <div style="margin-top: -30px;position: relative;z-index: 100;">

    <div class="top-switch">

      <div class="switch-tab" v-if="selected==1">
        <div class="second-tab" @click="switchTab(1)" style="background-color: #fff;color: #EA3928;">
          经营分析</div>
      </div>
      <div class="switch-tab" v-if="selected!=1">
        <div class="second-tab" @click="switchTab(1)" style="background-color: #EA3928;color: #fff;">
          经营分析</div>
      </div>

      <div class="switch-tab" v-if="selected==2">
        <div class="second-tab" @click="switchTab(2)" style="background-color: #fff;color: #EA3928;">
          公司简况</div>
      </div>
      <div class="switch-tab" v-if="selected!=2">
        <div class="second-tab" @click="switchTab(2)" style="background-color: #EA3928;color: #fff;">
          公司简况</div>
      </div>

      <div class="switch-tab" v-if="selected==3">
        <div class="second-tab" @click="switchTab(3)" style="background-color: #fff;color: #EA3928;">
          风险监测</div>
      </div>
      <div class="switch-tab" v-if="selected!=3">
        <div class="second-tab" @click="switchTab(3)" style="background-color: #EA3928;color: #fff;">
          风险监测</div>
      </div>

      <div class="switch-tab" v-if="selected==4">
        <div class="second-tab" @click="switchTab(4)" style="background-color: #fff;color: #EA3928;">
          行业比较</div>
      </div>
      <div class="switch-tab" v-if="selected!=4">
        <div class="second-tab" @click="switchTab(4)" style="background-color: #EA3928;color: #fff;">
          行业比较</div>
      </div>

      <div class="switch-tab" v-if="selected==5">
        <div class="second-tab" @click="switchTab(5)" style="background-color: #fff;color: #EA3928;">
          财务报表</div>
      </div>
      <div class="switch-tab" v-if="selected!=5">
        <div class="second-tab" @click="switchTab(5)" style="background-color: #EA3928;color: #fff;">
          财务报表</div>
      </div>

    </div>


    <div class="content" style="margin-top: 20px;">

      <div>
        <router-view />
      </div>

      <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
        免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
      </div>

    </div>

    <div @click="goTop()"
      style="width: 50px;height: 50px;display: flex;flex-direction: column;align-items: center;position: fixed;right: 70px;bottom: 70px;cursor: pointer;">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path
            d="M15.3513 5.10724C14.7232 4.47903 13.8881 4.13296 13 4.13296C12.1119 4.13296 11.2768 4.47903 10.6489 5.10724L3.52168 12.2344C2.89364 12.8623 2.54772 13.6975 2.54772 14.5856C2.54772 15.4735 2.89364 16.3084 3.52168 16.9367C3.70048 17.1155 3.94297 17.2159 4.19583 17.216H7.59974V22.6743C7.59974 24.508 9.09141 25.9997 10.9248 25.9997H15.0752C16.9085 25.9997 18.4002 24.508 18.4002 22.6743V17.216H21.8044C22.0573 17.216 22.2998 17.1154 22.4786 16.9367C23.1068 16.3085 23.4525 15.4735 23.4525 14.5852C23.4524 13.6972 23.1065 12.8623 22.4783 12.2345L15.3513 5.10724ZM21.3479 15.309H17.4468C16.9202 15.309 16.4933 15.7358 16.4933 16.2625V22.6742C16.4933 23.4564 15.8571 24.0927 15.0752 24.0927H10.9248C10.1428 24.0927 9.5067 23.4564 9.5067 22.6742V16.2625C9.5067 15.7358 9.07978 15.309 8.55323 15.309H4.65286C4.33052 14.7649 4.40286 14.0501 4.86997 13.5827L11.9973 6.45551C12.2652 6.18766 12.6212 6.03992 13 6.03992C13.3788 6.03992 13.7348 6.18764 14.0028 6.45551L21.13 13.5827C21.398 13.8509 21.5456 14.2069 21.5456 14.5856C21.5456 14.8441 21.4768 15.0924 21.3479 15.309ZM3.91028 2.54261H22.09C22.8622 2.54261 23.4882 1.97338 23.4882 1.27131C23.4882 0.569232 22.8622 0 22.09 0H3.91028C3.13805 0 2.51172 0.569232 2.51172 1.27131C2.51172 1.97338 3.13805 2.54261 3.91028 2.54261Z"
            fill="#EA3928"></path>
        </svg>
      </div>
      <span style="font-size: 12px;color: #EA3928;">返回顶端</span>
    </div>

  </div>
</template>
    
<script>
import { linkName } from '../../../static/js/util';

export default {
  data() {
    return {
      comCode: '',
      comName: '',

      selected: 1,
    };
  },
  watch: {

  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.comName = this.$route.query.comName;

    //刷新页面后恢复选中
    if(this.$route.name=='business'){
      this.selected = 1;
    }else if(this.$route.name=='company'){
      this.selected = 2;
    }else if(this.$route.name=='riskMonitor'){
      this.selected = 3;
    }else if(this.$route.name=='industryComparison'){
      this.selected = 4;
    }else if(this.$route.name=='financialStatements'){
      this.selected = 5;
    }

  },
  methods: {
    goTop() {
      scrollTo(0, 0);
      window.onscroll();
    },
    switchTab(sign) {
      // $(".second-tab").css({ "background-color": "#EA3928", "color": "#fff" });
      // event.srcElement.style.backgroundColor = "#fff";
      // event.srcElement.style.color = "#EA3928";
      this.selected = sign;

      var pageName;
      if (sign == 1) {
        pageName = 'business';
      } else if (sign == 2) {
        pageName = 'company';
      } else if (sign == 3) {
        pageName = 'riskMonitor';
      } else if (sign == 4) {
        pageName = 'industryComparison';
      } else if (sign == 5) {
        pageName = 'financialStatements';
      }
      linkName(this, pageName, {comCode: this.comCode, comName: this.comName});
    }
  }
};
</script>
    
<style scoped>
.top-switch {
  height: 40px;
  display: flex;
  background-color: rgb(234, 57, 40);
  padding-left: 200px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top: 1px solid #ddd;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.switch-tab {
  width: 130px;
  text-align: center;
}

.second-tab {
  line-height: 40px;
  height: 40px;
  display: inline-block;
  padding: 0 10px;
  cursor: pointer;
}
</style>